import { useEffect } from 'react';
import { useLoader } from './LoaderContext';
import client from './rest';

const LOADER_CLOSE_DELAY = 3000;

const useAxiosInterceptors = () => {
    const { setLoading } = useLoader();

    useEffect(() => {
        const requestInterceptor = client.interceptors.request.use(
            (request) => {
                if (!request.skipLoader) {
                    setLoading(true);
                }
                return request;
            },
            (error) => {
                if (!error.config?.skipLoader) {
                    setTimeout(() => { setLoading(false) }, LOADER_CLOSE_DELAY);
                }
                return Promise.reject(error);
            }
        );

        const responseInterceptor = client.interceptors.response.use(
            (response) => {
                if (!response.config.skipLoader) {
                    setTimeout(() => { setLoading(false) }, LOADER_CLOSE_DELAY);
                }
                return response;
            },
            (error) => {
                if (!error.config?.skipLoader) {
                    setTimeout(() => { setLoading(false) }, LOADER_CLOSE_DELAY);
                }
                return Promise.reject(error);
            }
        );

        return () => {
            client.interceptors.request.eject(requestInterceptor);
            client.interceptors.response.eject(responseInterceptor);
        };
    }, [setLoading]);
};

export default useAxiosInterceptors;